import { ufn } from '@edifecs/fp-ui-lib';

export class StringUtils {
    public static parseText(text: string | undefined, length: number): string | undefined {
        if (ufn.isText(text) && text.length > length) {
            text = text.slice(0, length);
        }

        return text;
    }
}
